<template>
  <div>
    <slot name="options"></slot>
    <PDFViewer v-if="pdfData" :data="pdfData" />
    <kanban-board v-else :stages="stages" :blocks="blocks" @update-block="updateBlock">
      <div v-for="stage in stages" :slot="stage" :key="stage">
        <h5 class="text-center text-danger mb-4">
          <span v-if="hidePopovers">{{ stage }}</span>
          <BaseLabelWithPopover :label="stage" width="250px" v-else-if="!hidePopovers && stage === 'Highlights'">
            <h6>Sales Flyer (PDF)</h6>
            <hr><img src="/img/popover/ConsumerSection_PopOver_Highlight.png" alt="" width="250">
            <table style="width: 100%;">
            <tbody>
            <tr>
            <td style="text-align: center;"><strong>18</strong>  Lines<br></td>
            <td style="text-align: center;"><strong>18</strong>  Lines<br></td>
            <td style="text-align: center;"><strong>20</strong>  Lines<br></td>
            </tr>
            </tbody>
            </table>
            <p>&nbsp;</p>
            <h6>Landing Page (Online): </h6>
            <hr><img src="/img/popover/ConsumerSection_PopOver_Highlight_L.png" alt="" width="250">
          </BaseLabelWithPopover>
          <BaseLabelWithPopover :label="stage" width="250px"  v-else-if="!hidePopovers && stage === 'Included'">
            <h6>Sales Flyer (PDF)</h6>
            <hr><img src="/img/popover/ConsumerSection_PopOver_Inclusion.png" alt="" width="250">
            <table style="width: 100%;">
            <tbody>
            <tr>
            <td style="text-align: center;"><strong>18</strong>  Lines<br></td>
            <td style="text-align: center;"><strong>11</strong>  Lines<br></td>
            <td style="text-align: center;"><strong>10</strong>  Lines<br></td>
            </tr>
            </tbody>
            </table>
            <p>&nbsp;</p>
            <h6>Landing Page (Online): </h6>
            <hr><img src="/img/popover/ConsumerSection_PopOver_Inclusion_L.png" alt="" width="250">
          </BaseLabelWithPopover>
        </h5>
        <button
          class="btn btn-sm btn-link"
          @click.prevent="() => addBlock(stage)"
          :disabled="isCompletedQuote || isImporting"
        >
          <font-awesome-icon
            :icon="['fas', 'plus']"
            size="lg"
            class="mr-1"
          />Add another card
        </button>
      </div>
      <div v-for="(block,indexmain) in blocks" :slot="block.id" :key="block.id">
        <div class="text-center">
          <strong v-show="!block.isEditing" v-html="block.title"></strong>
          <div v-show="block.isEditing">
            <BaseInput
              class
              type="text"
              placeholder="Card title goes here"
              v-model="block.title"
              :isLargeSize="false"
              @keyup.enter="saveEditing($event, block)"
              :disabled="isCompletedQuote || isImporting"
            />
          </div>
        </div>
        <div class="text-center">
          <button
            class="btn btn-sm btn-link border-0"
            v-show="!block.isEditing"
            @click.prevent="() => toggle(block)"
            :disabled="isCompletedQuote || isImporting"
          >
            <font-awesome-icon :icon="['fas', 'pen']" size="sm" class="mr-1" />
          </button>
          <button
            class="btn btn-sm btn-link border-0"
            v-show="block.isEditing"
            @click.prevent="() => saveEditing($event, block)"
            :disabled="isCompletedQuote || isImporting"
          >
            <font-awesome-icon
              :icon="['fas', 'check']"
              size="sm"
              class="mr-1"
            />
          </button>
          <button
            class="btn btn-sm btn-link border-0"
            @click.prevent="() => addItem(block)"
            :disabled="isCompletedQuote || isImporting"
          >
            <font-awesome-icon :icon="['fas', 'plus']" size="sm" class="mr-1" />
          </button>
          <button
            class="btn btn-sm btn-outline-danger border-0"
            @click.prevent="() => removeBlock(block)"
            :disabled="isCompletedQuote || isImporting"
          >
            <font-awesome-icon
              :icon="['fas', 'trash-alt']"
              size="sm"
              class="mr-1"
            />
          </button>
        </div>
        <div
          class="border bg-white my-4 px-3 py-3"
          v-for="(item, index) in block.items"
          :key="index"
        >
          <span v-show="!block.isEditing" v-html="item.items"></span>
          <div v-show="block.isEditing">
            <textarea
              class="form-control"
              type="text"
              rows="4"
              placeholder="item description goes here"
              :value="item.items"
              @keyup.enter="commitUpdateItem($event, block, item, index)"
              @input="commitUpdateItem($event, block, item, index)"
              @blur="commitUpdateItem($event, block, item, index)"
              :isLargeSize="false"
              :key="index"
              :disabled="isCompletedQuote || isImporting"></textarea>
          </div>
          <button
            class="btn btn-sm btn-outline-danger border-0 button-item"
            @click.prevent="() => removeItem(block, item, index,indexmain)"
            :disabled="isCompletedQuote || isImporting"
          >
            <font-awesome-icon
              :icon="['fas', 'trash-alt']"
              size="sm"
              class="mr-1"
            />
          </button>
        </div>
      </div>
    </kanban-board>
  </div>
</template>

<script>
import PDFViewer from "@/components/_shared/PDFViewer.vue";

export default {
  name: 'TabIncluded',
  components: {PDFViewer},
  props: {
    dataRootKey: {
      type: String,
      required: true
    },
    stages: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    },
    hidePopovers: {
      type: Boolean,
      default: true
    },
    isImporting: {
      type: Boolean,
      required: false
    },
    pdfData: {
      type: String,
      default: ""
    },
  },
  data () {
    return {
      blocks: [],
      listPrimitive: null
    }
  },
  beforeCreate () {
    this.$nextTick(function () {
      this.loadBlocks()
    })
  },
  methods: {
    loadBlocks () {
      this.blocks = []
      this.oldValueAux = ''

      var highlights = this.data.length ? this.data[0].highlights : []
      var included = this.data.length ? this.data[0].whatsincluded : []
      var notincluded = this.data.length ? this.data[0].whatsnotincluded : []

      if (highlights && highlights.length) {
        highlights.forEach(e => {
          this.blocks.push({
            id: e.id,
            status: 'Highlights',
            title: e.title,
            items: e.items,
            isEditing: false
          })
        })
      }

      if (included && included.length) {
        included.forEach(e => {
          this.blocks.push({
            id: e.id,
            status: 'Included',
            title: e.title,
            items: e.items,
            isEditing: false
          })
        })
      }

      if (notincluded && notincluded.length) {
        notincluded.forEach(e => {
          this.blocks.push({
            id: e.id,
            status: 'Not Included',
            title: e.title,
            items: e.items,
            isEditing: false
          })
        })
      }
    },
    toggle (block) {
      block.isEditing = !block.isEditing
    },
    saveEditing (e, block) {
      e.target.focus()
      this.toggle(block)
      this.commitUpdate(block)
    },
    updateBlock (id, status) {
      var current = this.blocks.find(b => String(b.id) === String(id))
      this.commitRemove(current)
      this.commitSave(status, current)
      current.status = status
    },
    addBlock (status) {
      var id = 'new-' + this.blocks.length
      var current = {
        title: 'Untitled new card-' + (this.blocks.length + 1),
        items: [
          {
            id: null,
            items: 'Untitled new item-1',
            old: 1
          }
        ],
        old: id
      }
      this.blocks.push({
        id: id,
        status: status,
        title: current.title,
        items: current.items,
        isEditing: false,
        old: id
      })
      this.commitSave(status, current)
      this.$nextTick(() => {
        var element = this.$el.querySelector(`li[data-block-id="${id}"]`)
        element.className += ' toAddParent'
        this.$scrollTo(element, {
          duration: 800,
          offset: -95
        })
      })
    },
    addItem (block) {
      this.commitSaveItem(block)
      this.$nextTick(() => {
        var element = this.$el.querySelector(`li[data-block-id="${block.id}"]>div>div:last-child`)
        element.className += ' toAddChild'
        this.$scrollTo(element, {
          duration: 800,
          offset: -95
        })
      })
    },
    removeBlock (item) {
      var current = this.blocks.find(b => String(b.id) === String(item.id))
      this.$el.querySelector(`li[data-block-id="${item.id}"]`).className +=
        ' toDeleteParent'
      this.commitRemove(current)
    },
    removeItem (block, item, index, indexmain) {
      var position = block.items.findIndex(
        b => String(b.id) === String(item.id)
      )
      var parent = this.$el.querySelector(
        `li[data-block-id="${block.id}"]>div`
      )
      if (!position) {
        position = block.items.findIndex(
          b => String(b.old) === String(item.old)
        )
      }

      if (parent.childElementCount - 2 === 1) this.removeBlock(block)
      else {
        this.$el.querySelector(
          `li[data-block-id="${block.id}"]>div>div:nth-child(${position + 3})`
        ).className += ' toDeleteChild'
      }
      this.commitRemoveItem(block, item)
    },
    commitSave (status, item) {
      item.dataRootKey = this.dataRootKey
      switch (status) {
        case 'Highlights':
          if (this.dataRootKey === 'consumer_section') {
            this.$store.commit('opportunity/TEMP_SAVE_HIGHLIGHT_SALES_FLYER', item)
          } else {
            this.$store.commit('opportunity/TEMP_SAVE_HIGHLIGHT', item)
          }
          break

        case 'Included':
          if (this.dataRootKey === 'consumer_section') {
            this.$store.commit('opportunity/TEMP_SAVE_INCLUDED_SALES_FLYER', item)
          } else {
            this.$store.commit('opportunity/TEMP_SAVE_INCLUDED', item)
          }
          break

        case 'Not Included':
          if (this.dataRootKey === 'consumer_section') {
            this.$store.commit('opportunity/TEMP_SAVE_NOT_INCLUDED_SALES_FLYER', item)
          } else {
            this.$store.commit('opportunity/TEMP_SAVE_NOT_INCLUDED', item)
          }
          break

        default:
          break
      }
    },
    commitRemove (item) {
      item.dataRootKey = this.dataRootKey
      switch (item.status) {
        case 'Highlights':
          if (this.dataRootKey === 'consumer_section') {
            this.$store.commit('opportunity/TEMP_REMOVE_HIGHLIGHT_SALES_FLYER', item)
          } else {
            this.$store.commit('opportunity/TEMP_REMOVE_HIGHLIGHT', item)
          }
          break

        case 'Included':
          if (this.dataRootKey === 'consumer_section') {
            this.$store.commit('opportunity/TEMP_REMOVE_INCLUDED_SALES_FLYER', item)
          } else {
            this.$store.commit('opportunity/TEMP_REMOVE_INCLUDED', item)
          }
          break

        case 'Not Included':
          if (this.dataRootKey === 'consumer_section') {
            this.$store.commit('opportunity/TEMP_REMOVE_NOT_INCLUDED_SALES_FLYER', item)
          } else {
            this.$store.commit('opportunity/TEMP_REMOVE_NOT_INCLUDED', item)
          }
          break

        default:
          break
      }
    },
    commitUpdate (item) {
      item.dataRootKey = this.dataRootKey
      if (this.dataRootKey === 'consumer_section') {
        this.$store.commit('opportunity/TEMP_UPDATE_INCLUDED_SALES_FLYER', item)
      } else {
        this.$store.commit('opportunity/TEMP_UPDATE_INCLUDED', item)
      }
    },
    commitSaveItem (block) {
      block.dataRootKey = this.dataRootKey
      if (this.dataRootKey === 'consumer_section') {
        this.$store.commit('opportunity/TEMP_SAVE_ITEM_SALES_FLYER', block)
      } else {
        this.$store.commit('opportunity/TEMP_SAVE_ITEM', block)
      }
    },
    commitRemoveItem (block, item) {
      var data = {
        parent: block,
        child: item,
        dataRootKey: this.dataRootKey
      }
      if (this.dataRootKey === 'consumer_section') {
        this.$store.commit('opportunity/TEMP_REMOVE_ITEM_SALES_FLYER', data)
      } else {
        this.$store.commit('opportunity/TEMP_REMOVE_ITEM', data)
      }
    },
    commitUpdateItem (e, block, item, index) {
      // e.target.parentElement.parentElement.className += ' toEditChild'
      var data = {
        parent: block,
        child: item,
        new: e.target.value,
        dataRootKey: this.dataRootKey
      }
      if (this.dataRootKey === 'consumer_section') {
        this.$store.commit('opportunity/TEMP_UPDATE_ITEM_SALES_FLYER', data)
      } else {
        this.$store.commit('opportunity/TEMP_UPDATE_ITEM', data)
      }
    }
  },
  watch: {
    data: function (val) {
      this.loadBlocks()
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/components/highlight/main.scss";
</style>
